import React, { useMemo } from 'react';
import JoditEditor from 'jodit-react';
import './style.css';

function BixJoditEditor({
  joditRef, joditValue, handleEditorChange,editorPlaceHolder
}) {
  const config = useMemo(() => ({
			placeholder: editorPlaceHolder || 'Start typings...',
		}),
		[editorPlaceHolder]
	);
  return (
    <div>
      <JoditEditor
        ref={joditRef}
        value={joditValue}
        config={config}
        onChange={(content) => handleEditorChange(content)}
      />
    </div>
  );
}

export default BixJoditEditor;
